import circlesLogo from '../../../../assets/circlesLogoBlackSmall.svg';
import { AdvantageCell } from '@7chairs/types';
import {
  AdvantagesSectionCellElement,
  AdvantagesSectionCellText,
  AdvantagesSectionCirclesLogo,
  AdvantagesSectionCirclesLogoText,
  AdvantagesSectionLogoWrapper,
} from './AdvantagesSectionCell.style';

interface AdvantagesSectionCellProps {
  cell?: AdvantageCell;
  isHeader: boolean;
  columnIndex: number;
  isCellFromLastRow: boolean;
}

export const AdvantagesSectionCell = (props: AdvantagesSectionCellProps) => {
  const { columnIndex, isHeader, cell, isCellFromLastRow } = props;

  const isFirstCell = columnIndex === 0;
  const whiteBg = columnIndex === 1 && !isHeader;

  const cellProps = {
    isHeader,
    isFirstCell,
    whiteBg,
    isCellFromLastRow,
  };

  if (!cell) {
    return <AdvantagesSectionCellElement {...cellProps} />;
  }

  if (cell.type === 'circles-logo-cell') {
    return (
      <AdvantagesSectionCellElement {...cellProps}>
        <AdvantagesSectionLogoWrapper>
          <AdvantagesSectionCirclesLogo src={circlesLogo} />
          <AdvantagesSectionCirclesLogoText>Circles</AdvantagesSectionCirclesLogoText>
        </AdvantagesSectionLogoWrapper>
      </AdvantagesSectionCellElement>
    );
  }

  const text =
    cell.text &&
    cell.text.map((textMeta, index) => (
      <AdvantagesSectionCellText bold={textMeta.bold} key={index}>
        {textMeta.text}
      </AdvantagesSectionCellText>
    ));

  return (
    <AdvantagesSectionCellElement {...cellProps}>
      <div>{text}</div>
    </AdvantagesSectionCellElement>
  );
};
